import Icon01 from "./icons/E-WEB-Goal-01.png";
import Icon02 from "./icons/E-WEB-Goal-02.png";
import Icon03 from "./icons/E-WEB-Goal-03.png";
import Icon04 from "./icons/E-WEB-Goal-04.png";
import Icon05 from "./icons/E-WEB-Goal-05.png";
import Icon06 from "./icons/E-WEB-Goal-06.png";
import Icon07 from "./icons/E-WEB-Goal-07.png";
import Icon08 from "./icons/E-WEB-Goal-08.png";
import Icon09 from "./icons/E-WEB-Goal-09.png";
import Icon10 from "./icons/E-WEB-Goal-10.png";
import Icon11 from "./icons/E-WEB-Goal-11.png";
import Icon12 from "./icons/E-WEB-Goal-12.png";
import Icon13 from "./icons/E-WEB-Goal-13.png";
import Icon14 from "./icons/E-WEB-Goal-14.png";
import Icon15 from "./icons/E-WEB-Goal-15.png";
import Icon16 from "./icons/E-WEB-Goal-16.png";
import Icon17 from "./icons/E-WEB-Goal-17.png";

const iconUndSDGoalsList = [
  { id: 1, name: "No Poverty", file: Icon01 },
  { id: 2, name: "Zero Hunger", file: Icon02 },
  { id: 3, name: "Good Health and Well-being", file: Icon03 },
  { id: 4, name: "Quality Education", file: Icon04 },
  { id: 5, name: "Gender Equality", file: Icon05 },
  { id: 6, name: "Clean Water and Sanitation", file: Icon06 },
  { id: 7, name: "Affordable and Clean Energy", file: Icon07 },
  { id: 8, name: "Decent Work and Economic Growth", file: Icon08 },
  { id: 9, name: "Industry, Innovation and Infrastructure", file: Icon09 },
  { id: 10, name: "Reduced Inequalities", file: Icon10 },
  { id: 11, name: "Sustainable Cities and Communities", file: Icon11 },
  { id: 12, name: "Responsible Consumption and Production", file: Icon12 },
  { id: 13, name: "Climate Action", file: Icon13 },
  { id: 14, name: "Life Below Water", file: Icon14 },
  { id: 15, name: "Life on Land", file: Icon15 },
  { id: 16, name: "Peace, Justice and Strong Institutions", file: Icon16 },
  { id: 17, name: "Partnerships for the Goals", file: Icon17 },
];

export default iconUndSDGoalsList;